"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _image = _interopRequireDefault(require("@ingka/image"));
var _aspectRatioBox = _interopRequireDefault(require("@ingka/aspect-ratio-box"));
var _paymentLogo = _interopRequireDefault(require("@ingka/payment-logo"));
var _AnimateHeight = _interopRequireDefault(require("./AnimateHeight"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ChoiceItem = _ref => {
  let {
    id,
    className,
    children,
    disabled,
    subtle,
    href,
    image,
    imagePosition,
    paymentLogo,
    onClick,
    selected,
    prefix,
    caption,
    title,
    value,
    controlProps,
    ...other
  } = _ref;
  const baseClass = `${prefix}choice-item`;
  const classes = (0, _classnames.default)(baseClass, selected && `${baseClass}--selected`, subtle && `${baseClass}--subtle`, imagePosition === 'trailing' && `${baseClass}--trailing-image`, !caption && `${baseClass}--centered`, className);
  const ChoiceAction = href ? 'a' : 'button';
  return _react.default.createElement("div", _extends({}, other, {
    id: id,
    className: classes
  }), _react.default.createElement(ChoiceAction, _extends({
    href: href,
    type: !href && 'button',
    rel: href && 'noopener noreferrer',
    "aria-pressed": !href && selected,
    className: `${baseClass}__action`,
    disabled: disabled,
    onClick: () => onClick(id)
  }, controlProps), paymentLogo && !image && _react.default.createElement(_paymentLogo.default, {
    size: paymentLogo.size,
    src: paymentLogo.src,
    alt: paymentLogo.alt,
    prefix: prefix
  }), image && _react.default.createElement("span", {
    className: `${baseClass}__image`
  }, _react.default.createElement(_aspectRatioBox.default, {
    ratio: "square",
    prefix: prefix
  }, _react.default.createElement(_image.default, _extends({
    prefix: prefix
  }, image)))), _react.default.createElement("span", {
    className: `${baseClass}__content`
  }, _react.default.createElement("span", {
    className: `${baseClass}__title`
  }, title), caption && _react.default.createElement("span", {
    className: `${baseClass}__caption`
  }, caption)), value && _react.default.createElement("span", {
    className: `${baseClass}__value`
  }, value)), _react.default.createElement("span", {
    className: `${baseClass}__border`,
    "aria-hidden": "true"
  }), children && _react.default.createElement(_AnimateHeight.default, {
    animateOpacity: true,
    expanded: children && selected && !disabled
  }, _react.default.createElement("div", {
    className: `${baseClass}__nested`
  }, children)));
};
ChoiceItem.defaultProps = {
  prefix: '',
  imagePosition: 'leading',
  onClick: () => {}
};
var _default = ChoiceItem;
exports.default = _default;